/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
// import {OPKey} from '../../../pages/configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
// import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const rawMaterialJson = async (): Promise<any> => {
  const rawMaterials = useJSONStore.getState().rawMaterials;
  const token = useUserStore.getState().userToken;
  const setRawMaterials = useJSONStore.getState().setRawMaterials;
  // const companyDetails = useCompanyStore.getState().companyDetails;

  if (rawMaterials.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.rawMaterials}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setRawMaterials(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default rawMaterialJson;
